import React, { Component } from 'react'
import { Modal } from 'advenio-components'
import GroupActivity from '../Activity/GroupActivity'


class GroupModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      close: false,
      width: 0,
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  onClose = () => {
    this.setState({ close: true })
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  render() {
    return (
      <Modal
        isOpened={this.props.open}
        full
        onClose={this.props.closeModal}
        statePath="activity"
        actionType="sending"
        typePrefix="ACTIVITY"
      >
        <GroupActivity
          children={this.props.children}
          closeModal={this.props.closeModal}
          categories={this.props.categories}
          classrooms={this.props.classrooms}
          postGroupActivity={this.props.postGroupActivity}
          user={this.props.user}
          loading={this.props.loading}
        />
      </Modal>
    )
  }
}

export default GroupModal



// WEBPACK FOOTER //
// ./src/Components/ModalContainer/GroupModal.jsx